import Vue from 'vue'
import Router from 'vue-router'

// Auth
import Auth from '@/components/Auth/Auth'
import Login from '@/components/Auth/Login'
import LoginSSO from '@/components/Auth/LoginSSO'
import AcceptNewEmail from '@/components/Auth/AcceptNewEmail'
import PasswordNew from '@/components/Auth/PasswordNew'
import PasswordRedefined from '@/components/Auth/PasswordRedefined'
import NewMember from '@/components/Auth/NewMember'
import OneTimeToken from '@/components/Auth/OneTimeToken'
// Dashboard
import Main from '@/components/Main'

// MyAccount
import MyAccount from '@/components/MyAccount/MyAccount'
// Profile
// import Profile from '@/components/Profile/Profile'
import ProfileDetails from '@/components/Profile/ProfileDetails'
import ProfileSecurity from '@/components/Profile/ProfileSecurity'
import ProfileChangeEmail from '@/components/Profile/ProfileChangeEmail'
import ProfilePassword from '@/components/Profile/ProfilePassword'
import ProfileTwofa from '@/components/Profile/ProfileTwofa'
import ProfileTwofaEnable from '@/components/Profile/ProfileTwofaEnable'
import ProfileTwofaDisable from '@/components/Profile/ProfileTwofaDisable'
import ProfileEmailSettings from '@/components/ProfileEmailSettings/ProfileEmailSettings'
import ProfileCalendarSettings from '@/components/ProfileCalendarSettings/ProfileCalendarSettings'
import ProfileApikey from '@/components/Profile/ProfileApikey'
import Session from '@/components/Session/Session'
import Notify from '@/components/Notify/Notify'
import BrowserExtension from '@/components/BrowserExtension/BrowserExtension'
// Job List
import JobList from '@/components/JobList/JobList'
// Job
import Job from '@/components/Job/Job'
import JobBoard from '@/components/Job/JobBoard/JobBoard'
import JobGrid from '@/components/Job/JobGrid/JobGrid'
import JobRecommended from '@/components/Job/JobRecommended/JobRecommended'
import JobAdvertise from '@/components/Job/JobAdvertise/JobAdvertise'
import JobLog from '@/components/Job/JobLog/JobLog'
import JobAttach from '@/components/Job/JobAttach/JobAttach'
import JobReport from '@/components/Job/JobReport/JobReport'
import JobSeeker from '@/components/Job/JobSeeker/JobSeeker'
import JobProfile from '@/components/Job/JobProfile/JobProfile'
import JobApprovalflow from '@/components/Job/JobApprovalflow/JobApprovalflow'
// Requisition List
import RequisitionList from '@/components/RequisitionList/RequisitionList'
// Requisition
import Requisition from '@/components/Requisition/Requisition'
// Billing
import Billing from '@/components/Billing/Billing'
import BillingPainel from '@/components/Billing/BillingPainel'
import BillingResume from '@/components/Billing/BillingResume'
import BillingInvoices from '@/components/Billing/BillingInvoices'
import BillingDetails from '@/components/Billing/BillingDetails'
import BillingPayment from '@/components/Billing/BillingPayment'
import BillingSteps from '@/components/Billing/BillingSteps'
// Meet
import Meet from '@/components/Meet/Meet'
// Candidate
import CandidateList from '@/components/CandidateList/CandidateList'
// Config
import Config from '@/components/Config/Config'
import Company from '@/components/Company/Company'
import Audit from '@/components/Audit/Audit'
import Departament from '@/components/Departament/Departament'
import RequisitionTemplate from '@/components/RequisitionTemplate/RequisitionTemplate'
import Questionform from '@/components/Questionform/Questionform'
import Videoform from '@/components/Videoform/Videoform'
import Scoreform from '@/components/Scoreform/Scoreform'
import Approvalrule from '@/components/Approvalrule/Approvalrule'
import Source from '@/components/Source/Source'
import Member from '@/components/Member/Member'
import MemberUser from '@/components/Member/MemberUser'
import MemberInvite from '@/components/Member/MemberInvite'
import Stage from '@/components/Stage/Stage'
import Dexport from '@/components/Dexport/Dexport'
import Dataimex from '@/components/Dataimex/Dataimex'
import Tag from '@/components/Tag/Tag'
import Role from '@/components/Role/Role'
import CustomFields from '@/components/CustomFields/CustomFields'
import CancelReason from '@/components/CancelReason/CancelReason'
import DisqualifyReason from '@/components/DisqualifyReason/DisqualifyReason'
import Templatemail from '@/components/Templatemail/Templatemail'
import Templateapply from '@/components/Templateapply/Templateapply'
import Contract from '@/components/Contract/Contract'
import ShareCandidate from '@/components/ShareCandidate/ShareCandidate'
import Careerpage from '@/components/Careerpage/Careerpage'
import CareerpagePages from '@/components/Careerpage/CareerpagePages'
import CareerpageConfig from '@/components/Careerpage/CareerpageConfig'
import Careersite from '@/components/Careersite/Careersite'
import BillingConsumption from '@/components/BillingConsumption/BillingConsumption'
import BillingConsumptionResume from '@/components/BillingConsumption/BillingConsumptionResume'
import BillingConsumptionDetails from '@/components/BillingConsumption/BillingConsumptionDetails'
// Account
// import Account from '@/components/Account/Account'
import AccountProfile from '@/components/Account/AccountProfile'
import AccountSetting from '@/components/Account/AccountSetting'
import AccountCareersite from '@/components/Account/AccountCareersite'
import AccountSocial from '@/components/Account/AccountSocial'
import Integrations from '@/components/Integrations/Integrations'
import ConnectionPage from '@/components/Integrations/ConnectionPage'
import AccountSSO from '@/components/Account/AccountSSO'
import AccountConversationalAgent from '@/components/Account/AccountConversationalAgent'
import AccountSlug from '@/components/Account/AccountSlug'
import AccountDomains from '@/components/Account/AccountDomains'
import AccountApplyfields from '@/components/Account/AccountApplyfields'
import AccountGDPR from '@/components/Account/AccountGDPR'
import AccountDiversity from '@/components/Account/AccountDiversity'
// Calendar
import Calendar from '@/components/Calendar/Calendar'
// Email
import Email from '@/components/Email/Email'
// Messaging
import Messaging from '@/components/Messaging/Messaging'
// Report
import ReportList from '@/components/Report/ReportList'
import ReportCancelReasons from '@/components/Report/ReportCancelReasons'
import ReportDisqualifyReasons from '@/components/Report/ReportDisqualifyReasons'
import ReportPipelineSpeed from '@/components/Report/ReportPipelineSpeed'
import ReportPipelineConversion from '@/components/Report/ReportPipelineConversion'
import ReportProductivity from '@/components/Report/ReportProductivity'
import ReportReferrals from '@/components/Report/ReportReferrals'
import ReportPostingAnalytic from '@/components/Report/ReportPostingAnalytic'
import ReportCandidateSource from '@/components/Report/ReportCandidateSource'
import ReportTimeToFill from '@/components/Report/ReportTimeToFill'
import ReportCurrentPipeline from '@/components/Report/ReportCurrentPipeline'
import ReportJobDetails from '@/components/Report/ReportJobDetails/List'
import ReportHireds from '@/components/Report/ReportHireds'
import ReportCurrentCandidate from '@/components/Report/ReportCurrentCandidate'

// Reporting
import Dashboard from '@/components/Dashboard/Dashboard'
import DashboardItem from '@/components/Dashboard/DashboardItem'
// DISC
import Disc from '@/components/Disc/Disc'

// middlewares
import AuthMiddleware from '@/middlewares/Auth'
import AccessMemberMiddleware from '@/middlewares/AccessMember'

// ## O erro NavigationDuplicated no Vue Router ocorre quando você tenta navegar para a mesma rota em que já está. Isso significa que sua aplicação está tentando navegar para "/calendar?type=agendaWeek&default_date=2023-07-02", mas já está nessa rota.
// ## Em versões anteriores do Vue Router, essa situação seria ignorada silenciosamente. No entanto, a partir da versão 3.1.0, o Vue Router começou a lançar esse erro para sinalizar a ocorrência de navegações duplicadas.
// ## https://stackoverflow.com/questions/57837758/navigationduplicated-navigating-to-current-location-search-is-not-allowed
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
// ##

Vue.use(Router)

export default new Router({
  routes: [
    /* meet */
    {
      path: '/meet/:token',
      name: 'meet',
      component: Meet
    },
    {
      path: '/',
      // name: 'dashboard',
      component: Main,
      beforeEnter: AuthMiddleware,
      children: [
        /* billing */
        {
          path: '/billing',
          name: 'billing',
          component: Billing,
          children: [{
            path: '',
            name: 'billing.painel',
            component: BillingPainel,
            children: [{
              path: '',
              name: 'billing.painel.resume',
              component: BillingResume
            }, {
              path: 'invoices',
              name: 'billing.painel.invoices',
              component: BillingInvoices
            }, {
              path: 'details',
              name: 'billing.painel.details',
              component: BillingDetails
            }, {
              path: 'payment',
              name: 'billing.painel.credcard',
              component: BillingPayment
            },
            {
              path: 'consumption',
              name: 'billing.painel.consumption',
              component: BillingConsumption,
              children: [{
                path: '',
                name: 'billing.painel.consumption',
                component: BillingConsumptionResume
              }, {
                path: ':type',
                name: 'billing.painel.consumption.resume',
                component: BillingConsumptionResume
              }, {
                path: ':type/details/:period',
                name: 'billing.painel.consumption.details',
                component: BillingConsumptionDetails
              }]
            }]
          }, {
            path: 'steps/:step',
            name: 'billing.steps',
            component: BillingSteps
          }]
        },
        /* jobs */
        {
          path: '',
          name: 'job.list',
          component: JobList
        },
        /* job */
        {
          path: 'job/:id',
          // name: 'job',
          component: Job,
          children: [
            {
              path: '',
              name: 'job.board',
              component: JobBoard
            },
            {
              path: 'grid',
              name: 'job.grid',
              component: JobGrid
            },
            {
              path: 'recommended',
              name: 'job.recommended',
              component: JobRecommended
            },
            {
              path: 'advertise',
              name: 'job.advertise',
              component: JobAdvertise
            },
            {
              path: 'log',
              name: 'job.log',
              component: JobLog
            },
            {
              path: 'attach',
              name: 'job.attach',
              component: JobAttach
            },
            {
              path: 'report',
              name: 'job.report',
              component: JobReport
            },
            {
              path: 'seeker/:profile_id?',
              name: 'job.seeker',
              component: JobSeeker
            },
            {
              path: 'profile',
              name: 'job.profile',
              component: JobProfile
            },
            {
              path: 'approvalflow',
              name: 'job.approvalflow',
              component: JobApprovalflow
            }
          ]
        },
        /* calendar */
        {
          path: 'calendar',
          name: 'calendar',
          component: Calendar
        },
        /* email */
        {
          path: 'email',
          name: 'email',
          component: Email
        },
        {
          path: 'email/:type',
          name: 'email.sent',
          component: Email
        },
        /* messaging */
        {
          path: 'messaging',
          name: 'messaging',
          component: Messaging
        },
        {
          path: 'messaging/new-conversation',
          name: 'messaging.new',
          component: Messaging
        },
        {
          path: 'messaging/conversations/:conversationId',
          name: 'messaging.conversation',
          component: Messaging
        },
        /* report */
        {
          path: 'reports',
          name: 'reports',
          component: ReportList,
          children: [
            {
              path: 'cancel-reasons',
              name: 'report.cancel.reasons',
              component: ReportCancelReasons
            },
            {
              path: 'disqualify-reasons',
              name: 'report.disqualify.reasons',
              component: ReportDisqualifyReasons
            },
            {
              path: 'pipeline-speed',
              name: 'report.pipeline.speed',
              component: ReportPipelineSpeed
            },
            {
              path: 'pipeline-conversion',
              name: 'report.pipeline.conversion',
              component: ReportPipelineConversion
            },
            {
              path: 'productivity',
              name: 'report.productivity',
              component: ReportProductivity
            },
            {
              path: 'referrals',
              name: 'report.referrals',
              component: ReportReferrals
            },
            {
              path: 'posting-analytics',
              name: 'posting.analytics',
              component: ReportPostingAnalytic
            },
            {
              path: 'candidate-source',
              name: 'candidate.source',
              component: ReportCandidateSource
            },
            {
              path: 'time-to-fill',
              name: 'report.time.to.fill',
              component: ReportTimeToFill
            },
            {
              path: 'current-pipeline',
              name: 'report.current.pipeline',
              component: ReportCurrentPipeline
            },
            {
              path: 'job-details',
              name: 'report.job.details',
              component: ReportJobDetails
            },
            {
              path: 'hireds',
              name: 'report.hireds',
              component: ReportHireds
            },
            {
              path: 'current-candidate',
              name: 'report.current.candidate',
              component: ReportCurrentCandidate
            }
          ]
        },
        /* report */
        {
          path: 'dashboards',
          name: 'dashboards',
          component: Dashboard,
          children: [
            {
              path: ':id',
              name: 'dashboards.item',
              component: DashboardItem
            }
          ]
        },
        /* candidates */
        {
          path: 'candidates',
          name: 'candidate.list',
          component: CandidateList
        },
        /* RequisitionList */
        {
          path: 'requisitions',
          name: 'requisition.list',
          component: RequisitionList
        },
        /* requisition */
        {
          path: 'requisition/:id',
          name: 'requisition',
          component: Requisition
        },
        /* config */
        {
          path: 'config',
          // name: 'config',
          component: Config,
          children: [
            {
              path: '',
              name: 'profile.details',
              component: ProfileDetails
            },
            {
              path: 'security',
              name: 'profile.security',
              component: ProfileSecurity
            },
            {
              path: 'change-email',
              name: 'profile.change.email',
              component: ProfileChangeEmail
            },
            {
              path: 'password',
              name: 'profile.password',
              component: ProfilePassword
            },
            {
              path: '2fa',
              name: 'profile.twofa',
              component: ProfileTwofa,
              children: [{
                path: 'enable',
                name: 'profile.twofa.enable',
                component: ProfileTwofaEnable
              }, {
                path: 'disable',
                name: 'profile.twofa.disable',
                component: ProfileTwofaDisable
              }]
            },
            {
              path: 'email-settings',
              name: 'email.settings',
              component: ProfileEmailSettings
            },
            {
              path: 'calendar-settings',
              name: 'calendar.settings',
              component: ProfileCalendarSettings
            },
            {
              path: 'notify',
              name: 'profile.notify',
              component: Notify
            },
            {
              path: 'api-key',
              name: 'apikey',
              component: ProfileApikey
            },
            {
              path: 'sessions',
              name: 'profile.session',
              component: Session
            },
            {
              path: 'browser-extension',
              name: 'browser.extension',
              component: BrowserExtension
            },
            {
              path: 'account',
              name: 'config.account',
              component: AccountProfile
            },
            {
              path: 'settings',
              name: 'config.setting',
              component: AccountSetting
            },
            {
              path: 'apply-notifications',
              name: 'config.applyNotifications',
              component: AccountCareersite
            },
            {
              path: 'sso',
              name: 'config.sso',
              component: AccountSSO
            },
            {
              path: 'conversational-agent',
              name: 'config.conversational.agent',
              component: AccountConversationalAgent
            },
            {
              path: 'slug',
              name: 'config.slug',
              component: AccountSlug
            },
            {
              path: 'domains',
              name: 'config.domains',
              component: AccountDomains
            },
            {
              path: 'apply-fields',
              name: 'config.apply.fields',
              component: AccountApplyfields
            },
            {
              path: 'gdpr',
              name: 'config.gdpr',
              component: AccountGDPR
            },
            {
              path: 'diversity',
              name: 'config.diversity',
              component: AccountDiversity
            },
            {
              path: 'company',
              name: 'config.company',
              component: Company
            },
            {
              path: 'audit',
              name: 'config.audit',
              component: Audit
            },
            {
              path: 'departament',
              name: 'config.departament',
              component: Departament
            },
            {
              path: 'requisition-template',
              name: 'config.requisitionTemplate',
              component: RequisitionTemplate
            },
            {
              path: 'tag',
              name: 'config.tag',
              component: Tag
            },
            {
              path: 'role',
              name: 'config.role',
              component: Role
            },
            {
              path: 'share-candidate',
              name: 'config.shareCandidate',
              component: ShareCandidate
            },
            {
              path: 'questionform',
              name: 'config.questionform',
              component: Questionform
            },
            {
              path: 'videoform',
              name: 'config.videoform',
              component: Videoform
            },
            {
              path: 'scoreform',
              name: 'config.scoreform',
              component: Scoreform
            },
            {
              path: 'approvalrule',
              name: 'config.approvalrule',
              component: Approvalrule
            },
            {
              path: 'source',
              name: 'config.source',
              component: Source
            },
            {
              path: 'careerpage',
              component: Careerpage,
              redirect: {name: 'config.careerpage.pages'},
              children: [{
                path: 'pages',
                name: 'config.careerpage.pages',
                component: CareerpagePages
              }, {
                path: 'config',
                name: 'config.careerpage.config',
                component: CareerpageConfig
              }, {
                path: 'social',
                name: 'config.careerpage.social',
                component: AccountSocial
              }]
            },
            {
              path: 'careersites',
              name: 'config.careersites',
              component: Careersite
            },
            {
              path: 'member',
              name: 'config.member',
              component: Member,
              children: [{
                path: '/',
                name: 'member.user',
                component: MemberUser
              }, {
                path: 'invite',
                name: 'member.invite',
                component: MemberInvite
              }]
            },
            {
              path: 'stage',
              name: 'config.stage',
              component: Stage
            },
            {
              path: 'dexport',
              name: 'config.dexport',
              component: Dexport
            },
            {
              path: 'dataimex',
              name: 'config.dataimex',
              component: Dataimex
            },
            {
              path: 'custom-fields',
              name: 'config.customfields',
              component: CustomFields
            },
            {
              path: 'cancel-reason',
              name: 'cancel.reason',
              component: CancelReason
            },
            {
              path: 'disqualify-reason',
              name: 'disqualify.reason',
              component: DisqualifyReason
            },
            {
              path: 'templatemail',
              name: 'templatemail',
              component: Templatemail
            },
            {
              path: 'templateapply',
              name: 'templateapply',
              component: Templateapply
            },
            {
              path: 'contract',
              name: 'contract',
              component: Contract
            },
            {
              path: 'integrations',
              name: 'config.integrations',
              component: Integrations
            },
            {
              path: 'integrations/:id',
              name: 'config.connection',
              component: ConnectionPage
            }
          ]
        }
      ]
    },
    /* auth */
    {
      path: '/auth',
      name: 'auth',
      component: Auth,
      children: [
        {
          path: '',
          name: 'login',
          component: Login
        },
        {
          path: 'sso',
          name: 'sso',
          component: LoginSSO
        },
        {
          path: 'one-time-token',
          name: 'one.time.token',
          component: OneTimeToken
        },
        {
          path: 'password/new',
          name: 'passwordNew',
          component: PasswordNew
        },
        {
          path: 'password/redefined/:token',
          name: 'passwordRedefined',
          component: PasswordRedefined
        },
        {
          path: 'new-member/:token',
          name: 'NewMember',
          component: NewMember
        },
        {
          path: 'accept-new-email/:token',
          name: 'acceptNewEmail',
          component: AcceptNewEmail
        },
        {
          path: 'access-member/:account_id/:token',
          name: 'access.member',
          beforeEnter: AccessMemberMiddleware
        }
      ]
    },
    /* accounts */
    {
      path: '/my-account',
      name: 'my.account',
      component: MyAccount
    },
    /* disc */
    {
      path: '/disc',
      name: 'disc',
      component: Disc
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js